export interface OrderSkuRemainingQty {
  product_id: number;
  product_name: string;
  variant_id: number | null;
  sku: string;
  title: string | null;
  /** Quantity on the customer order for this SKU */
  ordered_quantity: number;
  /** Quantity already on active PRs that have a non-cancelled PO */
  pr_quantity: number;
  remaining_quantity: number;
}

const normalizeSkuKey = (sku?: string | null): string =>
  (sku || "").trim().toLowerCase();

export const findOrderSkuRemainingQty = (
  rows: OrderSkuRemainingQty[],
  productId: number,
  variant?: { id?: number | null; sku?: string | null } | null,
): OrderSkuRemainingQty | null => {
  if (!variant) {
    return null;
  }

  const productSkuRows = rows.filter(
    (row) => row.product_id === productId && Boolean(row.sku?.trim()),
  );
  if (productSkuRows.length === 0) {
    return null;
  }

  const skuKey = normalizeSkuKey(variant.sku);
  if (skuKey) {
    const bySku = productSkuRows.find(
      (row) => normalizeSkuKey(row.sku) === skuKey,
    );
    if (bySku) {
      return bySku;
    }
  }

  if (variant.id != null) {
    const byVariantId = productSkuRows.find(
      (row) =>
        row.variant_id != null &&
        Number(row.variant_id) === Number(variant.id),
    );
    if (byVariantId) {
      return byVariantId;
    }
  }

  return null;
};
